import { render, staticRenderFns } from "./holiday_library.vue?vue&type=template&id=0ac7dfa6"
import script from "./holiday_library.vue?vue&type=script&lang=js"
export * from "./holiday_library.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports